import { useEffect, useRef } from 'react';

import { useAuthStore } from '~/stores/use-auth/store/authStore';
import {
  TOKEN_ALLOWANCE_FEATURE_FLAG,
  useFlags,
} from '~/stores/use-flags/useFlags';
import { useTokenUsage } from '~/stores/use-token-usage/useTokenUsage';

export const useTokenUsageFeatureFlag = () => {
  const userId = useAuthStore(state => state.user_id);
  const isEnabled = useFlags(state =>
    state.getFeatureFlagState(TOKEN_ALLOWANCE_FEATURE_FLAG)
  );
  const initializedUserIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!isEnabled || !userId) {
      initializedUserIdRef.current = undefined;
      return;
    }

    if (initializedUserIdRef.current === userId) {
      return;
    }

    initializedUserIdRef.current = userId;
    useTokenUsage.getState().initialise();
  }, [isEnabled, userId]);
};
